/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { OpcionesPlanes } from "./Opciones";
import "./styles.scss";

const Planes = ({
  numVisibles = 4,
  catalogo = {},
  handleRegresar = () => {},
  ModalPlan = null,
  ModalInfo = null,
  identificadorPlan = "llaveSumaAsegurada",
  prodCodigo = PRODUCTOS.LINEAS_FINANCIERAS,
  ...rest
}) => {
  const [planesVisibles, setPlanesVisibles] = useState([]);
  const [numPanelView, setNumPanelView] = useState(numVisibles);
  const [atrasActive, setAtrasActive] = useState(false);
  const [siguienteActive, setSiguienteActive] = useState(false);
  const [optSelected, setOptSelected] = useState(null);
  const [classToShow, setClassToShow] = useState("container-rcpa-planes");

  useEffect(() => {
    if (catalogo?.planes?.length > 0) {
      const selected = catalogo?.planes?.find((opt) => opt.seleccion === true);
      let visibles = catalogo?.planes?.slice(0, numVisibles);
      setOptSelected(selected || null);
      if (catalogo?.planes?.length > numVisibles) {
        setSiguienteActive(true);
      }
      if (selected) {
        let pagination = 0;
        while (visibles?.indexOf(selected) < 0) {
          pagination = pagination + numVisibles;
          visibles = catalogo?.planes?.slice(pagination, pagination + numVisibles);
          setPlanesVisibles(visibles);
          setNumPanelView(pagination + numVisibles);
          setSiguienteActive(false);
          setAtrasActive(true);
        }
        if (pagination + numVisibles < catalogo?.planes?.length) {
          setSiguienteActive(true);
        }
        if (visibles.length < numVisibles) {
          do {
            visibles.push(false);
          } while (visibles.length < numVisibles);

          setAtrasActive(true);
        }
      }
      if (catalogo?.planes?.length <= numVisibles) {
        setAtrasActive(false);
      }
      setPlanesVisibles(fillDivs(visibles?.filter((opt) => opt !== false)));
    }
  }, [catalogo]);

  const fillDivs = (planesToFill = []) => {
    let planes = [];
    switch (planesToFill?.length) {
      case 1:
        planes = [false, false, ...planesToFill, false, false];
        break;
      case 2:
      case 3:
        planes = [false, ...planesToFill, false];
        break;
      default:
        planes = [...planesToFill];
        break;
    }
    if (planes.length % 2 === 0) {
      setClassToShow(
        prodCodigo === PRODUCTOS.PRESUSCRITOS
          ? "container-sbs-planes"
          : "container-rcpa-planes"
      );
    } else {
      setClassToShow(
        prodCodigo === PRODUCTOS.PRESUSCRITOS
          ? "container-centrado-sbs"
          : "container-centrado-5"
      );
    }

    return [...planes];
  };

  const onClickSiguienteAtras = (boolSiguiente) => {
    if (boolSiguiente) {
      if (numPanelView + numVisibles - catalogo?.planes?.length <= numPanelView) {
        let numPlanes = catalogo?.planes?.slice(numPanelView, numPanelView + numVisibles);
        if (numPlanes.length < numVisibles) {
          numPlanes = fillDivs(numPlanes);
        }
        setPlanesVisibles(numPlanes);
        setNumPanelView(numPanelView + numVisibles);
        if (numPanelView + numVisibles - catalogo?.planes?.length >= 0) {
          setSiguienteActive(false);
        }
        setAtrasActive(true);
      }
    } else {
      setPlanesVisibles([
        ...fillDivs(
          catalogo?.planes?.slice(
            numPanelView - numVisibles * 2,
            numPanelView - numVisibles
          )
        ),
      ]);
      setNumPanelView(numPanelView - numVisibles);
      setSiguienteActive(true);
      if (numPanelView - numVisibles * 2 <= 0) {
        setAtrasActive(false);
      }
    }
  };
  return (
    <div className='col-12 d-flex justify-content-center flex-column border'>
      <OpcionesPlanes
        name='planSeleccionado'
        opciones={planesVisibles}
        opcionesCompletas={catalogo?.planes}
        etiquetas={catalogo?.etiquetas}
        siguienteActive={siguienteActive}
        atrasActive={atrasActive}
        onClickSiguienteAtras={onClickSiguienteAtras}
        opcionSeleccionada={optSelected}
        setOpcionSeleccionada={setOptSelected}
        ModalPlan={ModalPlan}
        ModalInfo={ModalInfo}
        identificadorPlan={identificadorPlan}
        classToShow={classToShow}
        {...rest}
      />
      <div className='row justify-content-center my-5'>
        <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
          <button className='btn btn-atras-api' onClick={handleRegresar}>
            Atrás
          </button>
        </div>
        <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
          <button disabled={!optSelected} className='btn btn-siguiente-api' type='submit'>
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Planes;
